"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = require("prop-types");
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constant2 = _interopRequireDefault(require("./constant"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var menuItem = {
  iconLeft: _propTypes.string,
  label: _propTypes.string,
  iconRight: _propTypes.string,
  redirectUrl: _propTypes.string,
  newTab: _propTypes.string,
  onClick: _propTypes.func,
  value: _propTypes.any
};
var menuSection = {
  title: _propTypes.string,
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)(menuItem)).isRequired
};
var iconTextConfig = {
  color: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
  size: (0, _propTypes.oneOf)(_constant.ARR_FONT_SIZE)
};
var _default = {
  PropTypes: {
    data: (0, _propTypes.arrayOf)((0, _propTypes.shape)(menuSection)).isRequired,
    dataConfig: (0, _propTypes.shape)({
      backgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
      activeBackgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
      titleColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
      titleSize: (0, _propTypes.oneOf)(_constant.ARR_FONT_SIZE)
    }),
    menuIconConfig: (0, _propTypes.shape)(_objectSpread(_objectSpread({}, iconTextConfig), {}, {
      icon: _propTypes.string
    })),
    leftIconConfig: (0, _propTypes.shape)(iconTextConfig),
    textConfig: (0, _propTypes.shape)(iconTextConfig),
    rightIconConfig: (0, _propTypes.shape)(iconTextConfig),
    closeButtonConfig: (0, _propTypes.shape)(_objectSpread(_objectSpread({}, iconTextConfig), {}, {
      icon: _propTypes.string
    })),
    onClose: _propTypes.func,
    zIndex: _propTypes.number,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    fireGtm: _propTypes.func,
    idConfig: (0, _propTypes.exact)({
      widgetName: _propTypes.string,
      parentName: _propTypes.string,
      index: _propTypes.string
    })
  },
  DefaultProps: {
    dataConfig: {
      backgroundColor: _constant2.default.DATA.BGCOLOR,
      activeBackgroundColor: _constant2.default.DATA.ACTIVE_BGCOLOR,
      titleColor: _constant2.default.DATA.TITLE_COLOR,
      titleSize: _constant2.default.DATA.TITLE_SIZE
    },
    menuIconConfig: {
      icon: _constant2.default.MENU.ICON,
      color: _constant2.default.MENU.COLOR,
      size: _constant2.default.MENU.SIZE
    },
    leftIconConfig: {
      color: _constant2.default.ICON_LEFT.COLOR,
      size: _constant2.default.ICON_LEFT.SIZE
    },
    textConfig: {
      color: _constant2.default.TEXT.COLOR,
      size: _constant2.default.TEXT.SIZE
    },
    rightIconConfig: {
      color: _constant2.default.ICON_RIGHT.COLOR,
      size: _constant2.default.ICON_RIGHT.SIZE
    },
    zIndex: _constant2.default.ZINDEX,
    closeButtonConfig: {
      icon: _constant2.default.CLOSE_BTN.ICON,
      color: _constant2.default.CLOSE_BTN.COLOR,
      size: _constant2.default.CLOSE_BTN.SIZE
    },
    theme: _constant.DEFAULT_THEME,
    accessible: true
  }
};
exports.default = _default;